import Logo from '../components/Logo'
import { 
    TextL,
 } from '../components'
import {
    WalletButton
} from '../ethComponents'
import ChangeLanguage from './Language'

import MuiAppBar from '@mui/material/AppBar';
import ButtonBase from '@mui/material/ButtonBase';
import Toolbar from '@mui/material/Toolbar';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import { styled } from '@mui/material/styles';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

function AppBar() {
    return (
        <>
            <MuiAppBar >
                <Container sx={{margin:'10px auto'}}>
                    <Stack direction='row' justifyContent='space-between' alignItems='center'>
                        <Logo size='1.4'> <TextL style={{marginLeft: '10px'}}> {process.env.TITLE} </TextL></Logo>
                        <Stack direction='row' spacing={1} alignItems='center'>
                            <WalletButton
                                buttonType={{
                                    size:'small',
                                    type: 'd'
                                }}
                            />
                            <VersionSwitch />
                            <ChangeLanguage variant='flag' />
                        </Stack>
                    </Stack>
                </Container>
            </MuiAppBar>
            <Toolbar />
        </>
    );
}

function VersionSwitch() {
    const location = useLocation()
    const [currentVersion, setCurrentVersion] = useState(() => getVersionFromPath(location.pathname))

    useEffect(() => {
        setCurrentVersion(getVersionFromPath(location.pathname))
    }, [location.pathname])

    const switchTo = (path, version) => {
        setCurrentVersion(version)
        window.location.href = `${path}${window.location.search}`
    }

    return (
        <VersionSwitchRoot aria-label='Version switch'>
            <VersionButton
                active={currentVersion === 'v1'}
                onClick={() => switchTo('/v1', 'v1')}
            >
                V1
            </VersionButton>
            <VersionButton
                active={currentVersion === 'v2'}
                onClick={() => switchTo('/', 'v2')}
            >
                V2
            </VersionButton>
        </VersionSwitchRoot>
    )
}

function getVersionFromPath(pathname) {
    return pathname === '/v1' ? 'v1' : 'v2'
}

const VersionSwitchRoot = styled('div')`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    padding: 0px 2px;
    
    border-radius: 999px;
    background: rgb(32 32 33);
`

function VersionButton({active, children, ...props}) {
    return (
        <ButtonBase
            aria-pressed={active}
            sx={{
                minWidth: 34,
                height: 28,
                padding: '0 10px',
                borderRadius: 999,
                color: active ? '#311b02' : '#d5d8df',
                background: active ? 'linear-gradient(45deg, rgb(5 255 238), rgb(88 255 11), rgb(255 237 58))' : 'transparent',
                fontSize: 12,
                fontWeight: 800,
                lineHeight: 1,
                transition: 'background .2s, color .2s, opacity .2s',
                '&:hover': {
                    opacity: .92,
                }
            }}
            {...props}
        >
            {children}
        </ButtonBase>
    )
}

export default AppBar
